export const expanded = state => state.previewModal.expanded
export const index = state => state.previewModal.index
